import { isContent, get, isAlignment, getProperty, debounce } from '@convenia/helpers'

export default {
  props: {
    /**
     * Table columns.
     */
    cols: {
      type: Array,
      validator: isContent,
      default: () => [],
    },

    /**
     * Table rows.
     */
    rows: {
      type: Array,
      validator: isContent,
      default: () => [],
    },

    /**
     * Wheter the table scroll shadow is greyish.
     */
    greyShadow: Boolean,

    /**
     * The table alignment.
     */
    align: {
      type: String,
      default: 'left',
      validator: isAlignment
    },

    /**
     * Skips list transitions
     */
    skipTransition: Boolean,
  },

  data () {
    return {
      tableScrollWidth: '0',
      observer: null,
      lastPosition: 0,
      position: 0
    }
  },

  methods: {
    getText: get,

    getElement (refName) {
      const ref = this.$refs[refName] || {}
      return ref.$el || ref
    },

    emitPaginate () {
      const el = this.getElement('tableBody')

      const { scrollTop } = el
      const { scrollHeight } = el
      const { clientHeight } = el
      const paginationThreshold = scrollHeight - 140
      const gap = 70
      this.lastPosition = this.position
      this.position = scrollTop

      /**
       * Emited when the user scrolls down to the end of the table's content.
       * @event paginate
       * @type {null}
       */
      if ((scrollTop + clientHeight) >= paginationThreshold) { this.$emit('paginate') }

      /**
       * Emited with true value, when user scrolls up, or false, when user scrolls down
       * @event scrollDirection
       * @type Boolean
       */
      if (scrollHeight <= window.innerHeight + this.headerHeight) {
        this.$emit('scrollDirection', 'up')
      } else if (this.position < this.headerHeight) {
        this.$emit('scrollDirection', 'up')
      } else if (this.position >= scrollHeight - clientHeight - this.headerHeight) {
        this.$emit('scrollDirection', 'down')
      } else if ((scrollTop + clientHeight) < paginationThreshold) {
        this.$emit('scrollDirection', (this.position > this.lastPosition) && (this.position > gap) ? 'down' : 'up')
      }
    },

    getClasses (index, type) {
      const custom = this.cols[index][type + 'Class']
      const classes = [
        custom,
        '-' + type,
        'cell',
        '-' + this.getAlignment(index)
      ]

      return classes
    },

    getStyle (col) {
      const style = {
        textAlign: col.align || this.align,
        display: col.hidden ? 'none' : undefined
      }

      return style
    },

    getAlignment (index) {
      const col = this.cols[index]
      const props = this.$props || this.props
      const alignment = getProperty('align', [ col, props ], isAlignment)
      return alignment
    },

    adjustTableScrollWidth: debounce(function debounced () {
      const element = this.getElement('tableBody')

      this.tableScrollWidth = `${element.offsetWidth - element.scrollWidth}px`

      this.$emit('table-scroll-width', this.tableScrollWidth)
    }, 100),

    destroyObserver () {
      if (this.observer) {
        this.observer.disconnect()
      }
      window.removeEventListener('resize', this.adjustTableScrollWidth)
    }
  },

  mounted () {
    this.observer = new MutationObserver(this.adjustTableScrollWidth)
    this.observer.observe(this.getElement('tableBody'), { childList: true })
    window.addEventListener('resize', this.adjustTableScrollWidth)
    this.$nextTick(this.adjustTableScrollWidth)
    setTimeout(this.adjustTableScrollWidth, 200)
  },

  beforeDestroy () {
    this.destroyObserver()
  },

  beforeUnmount () {
    this.destroyObserver()
  }
}
